"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { trackEvent } from "@/lib/analytics";

/**
 * Internal link into the AI governance pages that records where the click came from
 * (GA4 `agk_internal_link`, param `location`). No UTM tags: those would restart the session.
 */
export default function TrackedGovLink({
  href,
  location,
  className,
  children,
}: {
  href: string;
  location: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => trackEvent("agk_internal_link", { location, link_url: href })}
    >
      {children}
    </Link>
  );
}
